import { newBrunswickConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function NewBrunswickPage() {
  return <CityPageTemplate config={newBrunswickConfig} />;
}